<script setup lang="ts">
const props = defineProps({
  totalPages: {
    type: Number,
    required: true,
  },
  currentPage: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits<{
  (e: 'changePage', value: number): void;
}>();

function isCurrentPage(page: number) {
  return page === props.currentPage;
}

const commonClass =
  'border border-gray-400 py-3 px-5 underline hover:opacity-70 duration-300';

const isFirstPage = computed(() => {
  return props.currentPage === 1;
});

const isLastPage = computed(() => {
  return props.currentPage === props.totalPages;
});

function changePage(page: number) {
  emit('changePage', page);
}
</script>

<template>
  <div v-if="totalPages > 1" class="flex flex-wrap gap-3 justify-center">
    <button
      v-if="!isFirstPage"
      :class="commonClass"
      @click="changePage(currentPage - 1)"
    >
      前のページ
    </button>

    <button
      v-for="i in totalPages"
      :key="i"
      :class="{
        [commonClass]: true,
        'no-underline pointer-events-none': isCurrentPage(i),
      }"
      @click="changePage(i)"
    >
      {{ i }}
    </button>

    <button
      v-if="!isLastPage"
      :class="commonClass"
      @click="changePage(currentPage + 1)"
    >
      次のページ
    </button>
  </div>
</template>
